<style lang="scss" scoped="">
.mytable {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
  //#606672
}
.mytable /deep/ table {
  border-collapse: collapse;
}
.mytable /deep/ table tbody tr:first-child {
  height: 42px;
  font-size: 12px;
}
.mytable /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
}
.stateTable {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
  //#606672
}
.stateTable /deep/ table {
  border-collapse: collapse;
}
.stateTable /deep/ table tbody tr:first-child {
  height: 42px;
  font-size: 12px;
}
.stateTable /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
}
</style>

<template>
  <div ref="container" style="overflow: auto;position: relative">
    <div style="display: flex;justify-content: space-between;margin-top: 26px;">
      <div>
        <p style="color: #C0C4CC;font-size: 14px;">{{ $t('shebeimingcheng') }}</p>
        <p style="color: #FFFFFF;font-size: 24px;margin-top: 4px;">{{ equipment.name }}</p>
      </div>
      <div>
        <p style="color: #C0C4CC;font-size: 14px;">{{ $t('shebeixinghao') }}</p>
        <p style="color: #FFFFFF;font-size: 24px;margin-top: 4px;">{{ equipment.modelCode }}</p>
      </div>
      <div>
        <p style="color: #C0C4CC;font-size: 14px;">{{ $t('shebeiSN') }}</p>
        <p style="color: #FFFFFF;font-size: 24px;margin-top: 4px;">{{ equipment.sn }}</p>
      </div>
      <div>
        <p style="color: #C0C4CC;font-size: 14px;">{{ $t('chuchangriqi') }}</p>

        <p style="color: #FFFFFF;font-size: 24px;margin-top: 4px;">{{ equipment.leaveFactoryDate ? dayjs.unix(equipment.leaveFactoryDate / 1000).format('YYYY-MM-DD') : '-' }}</p>
      </div>
      <div></div>
    </div>
    <div class="stateTable" v-html="loc"></div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_equipment_statistics_tabs_info',
  components: {},
  props: {
    equipment: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tabsData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      refLongitude: null,
      refLatitude: null,
      distanceResult: null
    };
  },
  computed: {
    loc() {
      if (this.tabsData.tab.loc == undefined) {
        return;
      }
      let str = this.tabsData.tab.loc;
      str = this.base64.decode(str);
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) &&
        str.match(reg1).map(code => {
          let c = code.replace('[', '');
          c = c.replace(']', '');
          str = str.replace(code, this.$t(c));
        });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) &&
        str.match(reg2).map(code => {
          let c = code.replace('{', '');
          c = c.replace('}', '');
          if (!this.store.state.eqPoints[this.equipment.id][c]) {
            str = str.replace(code, '');
          }
          // 判断是否需要计算距离
          if (code.includes('loc_deviation') && this.store.state.eqPoints[this.equipment.id]['longitude']) {
            this.calculateDistance(this.tabsData.eqPoints['longitude'], this.tabsData.eqPoints['latitude']);
            str = str.replace(code, this.distanceResult);
          } else {
            str = str.replace(code, this.tabsData.eqPoints[c] == undefined ? '' : this.tabsData.eqPoints[c]);
          }
        });
      return str;
    }

    // current() {
    // 	return this.data
    // }
  },
  created() {},
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {},
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 500);
    },

    // 计算距离
    calculateDistance(realLongitude, realLatitude) {
      //获取设备参考坐标然后进行转换并计算
      this.http
        .get('/web/equipment/get', {
          params: {
            id: this.equipment.id
          }
        })
        .then(response => {
          if (!response.data.longitude || !response.data.latitude) {
            this.distanceResult = this.$t('weiweihucankaojingweidu');
            return;
          }
          this.refLongitude = response.data.longitude;
          this.refLatitude = response.data.latitude;

          const long1 = this.parseCoordinate(realLongitude);
          const lat1 = this.parseCoordinate(realLatitude);
          const long2 = this.parseCoordinate(this.parseRefCoordinates(this.refLongitude));
          const lat2 = this.parseCoordinate(this.parseRefCoordinates(this.refLatitude));
          // 地球半径，单位为米
          const radius = 6371000;
          const latDifference = (lat2 - lat1) * (Math.PI / 180);
          const longDifference = (long2 - long1) * (Math.PI / 180);
          const a = Math.sin(latDifference / 2) * Math.sin(latDifference / 2) + Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(longDifference / 2) * Math.sin(longDifference / 2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

          this.distanceResult = (radius * c).toFixed(2);
        });
    },
    // 解析设备参考坐标格式，东经113度20.48333分
    parseRefCoordinates(str) {
      const regex = /([东西南北])?纬?经?(\d{1,3}\.?\d{0,8})度(\d{1,3}\.?\d{0,8})分?/;
      const match = str.match(regex);

      if (match) {
        // 判断方向，东经、西经、北纬、南纬
        const direction = match[1];
        // 取出度数
        const degrees = Number(match[2]);
        // 取出分钟
        const minutes = Number(match[3]);
        // 初始化方向为空字符串
        let formattedDirection = '';
        if (direction === '东') {
          formattedDirection = 'E';
        } else if (direction === '西') {
          formattedDirection = 'W';
        } else if (direction === '北') {
          formattedDirection = 'N';
        } else if (direction === '南') {
          formattedDirection = 'S';
        }
        return `${degrees}° ${minutes.toFixed(8)}' ${formattedDirection}`;
      }
    },
    // 解析实际坐标并转换为度数，入参示例113° 20.466720' E或22° 48.980740' N
    parseCoordinate(coord) {
      const parts = coord.split(' ');
      const result = this.dmsToDecimal(Number(parts[0].replace('°', '')), Number(parts[1].replace("'", '')), parts[3]);
      return result;
    },

    // 实际坐标转换为弧度
    dmsToDecimal(degrees, minutes, direction) {
      return degrees + (minutes / 60 / 60) * (direction === 'W' || direction === 'S' ? -1 : 1);
    },

    formatCoord(coord) {
      return coord
        .replace(/°|'|E|N|W|S/g, '')
        .replace(/,/, ', ')
        .trim();
    }
  }
};
</script>
